import IMG_DEPOSIT_CARD_GB from 'assets/slickpay-splash/deposit.png';
import IMG_DEPOSIT_CARD_US from 'assets/slickpay-splash/deposit-us.png';
import IMG_NO_SHOW_CARD_GB from 'assets/slickpay-splash/no_show.png';
import IMG_NO_SHOW_CARD_US from 'assets/slickpay-splash/no_show-us.png';
import IMG_PROTECTION_CARD_GB from 'assets/slickpay-splash/protection.png';
import IMG_PROTECTION_CARD_US from 'assets/slickpay-splash/protection-us.png';

export const DEPOSIT_CARD_IMAGES = {
  US: IMG_DEPOSIT_CARD_US,
  GB: IMG_DEPOSIT_CARD_GB,
};

export const NO_SHOW_CARD_IMAGES = {
  US: IMG_NO_SHOW_CARD_US,
  GB: IMG_NO_SHOW_CARD_GB,
};

export const PROTECTION_CARD_IMAGES = {
  US: IMG_PROTECTION_CARD_US,
  GB: IMG_PROTECTION_CARD_GB,
};
